<template>
  <div>
    <div class="banner innerpageBanner">
<div class="container">
<div class="caption">
<div><h1>Inside Burgundy中文网</h1>
<p>了解更多关于我们网站和团队的故事</p>
</div>
</div>
</div>

<img src="https://image.insideburgundy.cn/insideburgundy/20190527/cc0743db747a4c3ba19c2915cb458cfd.png" alt="" class="cover-image">
</div>

    <div class="container">
      <searchBox  />

      <div class="breadcrumbWrap">
        <div class="breadcrumb" style="padding-top:20px">
            <span property="itemListElement" typeof="ListItem">
              <a
                property="item"
                typeof="WebPage"
                title="Go to Jasper Morris Inside Burgundy."
                href="#/"
                class="home"
              >
                <span property="name">首页</span>
              </a>
              <meta property="position" content="1">
            </span> /
          <span property="itemListElement" typeof="ListItem">
              <span property="name">关于Inside Burgundy</span>
              <meta property="position" content="2">
            </span>
        </div>
      </div>
    </div>

    <div class="container">

      <div class="entry">
        <h3 style="padding-bottom: 20px;padding-top: 20px;">Inside Burgundy中文网是每一位勃艮第爱好者的家园</h3>
        <p
          class="p1"
        >www.insideburgundy.cn提供有关于勃艮第葡萄酒的一切内容。Jasper Morris MW 2010年出版的经典著作《Inside Burgundy》涵盖了勃艮第的产区、葡萄园及酒庄介绍，被世界各地的葡萄酒爱好者誉为勃艮第发烧友的圣经，而本网站正是对这本著作最好的补充。</p>
        <p
          class="p1"
        >www.insideburgundy.cn向读者提供勃艮第产区和葡萄酒的最新动态，以及有关酒款的深度品鉴报告笔记，目的是使读者掌握更全面的信息以帮助购买决策。为此我们专门设立两套葡萄酒评价系统，即针对酒款质量的百分制系统，及指导选购的五星级系统。您可在网站的评分说明页面了解更多有关这两套评价系统的信息。</p>
        <h3>&nbsp;</h3>
        <h3 style="padding-bottom: 10px;">Jasper Morris MW</h3>
        <p>
          <img
            class="wp-image-7552 size-full alignleft"
            style="margin-right: 30px !important;"
            src="https://image.insideburgundy.cn/insideburgundy/20190527/1724682759a545a3941179f4ac954200.png"
            alt
            width="172"
            height="300"
          >
        </p>
        <div class="baokuo">
          <p class="p1">
            我自1979年开始进入葡萄酒行业，很快我就和勃艮第结缘，并在英国成立了一家勃艮第葡萄酒的进口公司Morris & Verdin Ltd，这家公司在1990年代成为英国首屈一指的勃艮第进口商。2013年我和合伙人将这家公司卖给了英国老牌酒商BBR（Berry Bros &Rudd），从那之后我在BBR一直担任勃艮第的买手和总监一职，直到2017年退休。在我的职业生涯中，我在1985年成为一名葡萄酒大师Master of Wine，并与2010年出版了我的勃艮第专著《Inside Burgundy》。
          </p>
          <p class="p1">
              大家今天仍然可以在网络和书店上找到这本书。离开商业的世界后，我开始了作为一位勃艮第酒评家的新生，2018年9月发布了Inside Burgundy网站，2019年6月，Inside Burgundy中文版www.insideburgundy.cn诞生。
          </p>
        </div>
        <h2>&nbsp;</h2>
        <h3 style="padding-bottom: 10px;">梅宁博</h3>
        <p>
          <img
            class="wp-image-7552 size-full alignleft"
            style="margin-right: 30px !important;"
            src="https://image.insideburgundy.cn/ningbo.jpg"
            alt
            width="172"
            height="230"
          >
        </p>
        <div class="baokuo">
          <p class="p1">2009年我偶然之间参加了一场葡萄酒品鉴会，那是勃艮第葡萄酒行业协会BIVB在中国做的第一场推广活动。</p>
          <p class="p1">
          一款来自夏布利产区的白葡萄酒让我心驰神往，我立刻决定辞掉当时的工作开始学习葡萄酒。经历了九九八十一难之后，我被全世界名列前茅的葡萄酒高校勃艮第商学院葡萄酒专业所录取，在此期间，我深入地学习法国尤其是勃艮第产区的葡萄酒，最终获得该校葡萄酒硕士学位。
          </p>
          <p class="p1">
          2013年回国之后，为了把我从葡萄酒中获得的乐趣分享给更多的人，我加入了一家当时国内领先的葡萄酒媒体公司，并担任主编，这份工作让我有机会游历世界各地的葡萄酒产区。
          </p>
          <p class="p1">
          最终，对勃艮第葡萄酒的热爱让我决心回到原点。2017年我创办了微信公众号“勃艮第指南”，并开始写作我的第一本勃艮第葡萄酒著作，我在一次有关勃艮第拍卖的采访中遇到了Jasper Morris MW，
            两人一拍即合，并于2019年正式加入Jasper Morris创办的Inside Burgundy团队，担任Inside Burgundy中文网主编。
          </p>
        </div>
        <p>&nbsp;</p>
      </div>

      <div class="image-block" style="width: 100%">
        <a  href="http://mp.weixin.qq.com/mp/homepage?__biz=MzU4Njk2ODA3Mw==&hid=13&sn=87f9b739a1d4b8be689377e85f2b830c&scene=18#wechat_redirect" target="_blank" class="item" style="margin-right: 15px">
          <img  class="img" src="https://static.drwine.cn/aboutus.png" alt="">
          <p class="bottom">关于我们</p>
        </a>
        <a href="https://mp.weixin.qq.com/s/7oksvc25G0FA5I1s_LCX6w"
           target="_blank"
           class="item" style="margin-left: 15px">
          <img class="img" src="https://static.drwine.cn/%E8%81%94%E7%B3%BB%E6%88%91%E4%BB%AC.png" alt="">
          <p class="bottom">联系我们</p>
        </a>
      </div>

      <div class="gridBoxes four">
        <h2 class="animate fadeInUp triggeredCSS3">最新资讯</h2>
        <ul>
          <li class="animate fadeInUp triggeredCSS3" v-for="item in newlatest" :key='item.id'>
            <div class="content">
              <a :href="`#/latestinformation?id=${item.id}`">
                <div class="img">
                  <img
                    :src="item.image"
                    alt="Frost Patrol: Sunday April 14th"
                    class="cover-image"
                  >
                </div>
              </a>
              <div class="discription">
                <h6>
                  <a :href="`#/latestinformation?id=${item.id}`">
                    {{item.title}}
                  </a>
                </h6>
                {{item.introduction}}
              </div>
              <a :href="`#/latestinformation?id=${item.id}`" class="readmore">阅读更多</a>
            </div>
          </li>

        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import searchBox from '../template/search';
import ajax from '../ajax'

export default {
  data(){
    return {
      newlatest:[]
    }
  },
  components:{
    searchBox
  },
  created() {
    this.getNewlatest()
  },
  methods: {
    getNewlatest(){
      ajax.getNewsLatest().then(res=>{
        this.newlatest = res.data
      })
    },
    hreftwo() {
      this.$router.push({ path: "./insideburgundy" });
    },
    changeActive($event) {
      $event.currentTarget.style = "border-bottom: 4px solid #990033;";
    },
    removeActive($event) {
      $event.currentTarget.style = "";
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/JASPER.vue